import React from "react";
import Chip from "@mui/material/Chip";

const PaymentStatusBadge = ({ paymentStatus }) => {
  return (
    <Chip
      label={paymentStatus ? "Paid" : "Due"}
      style={{
        backgroundColor: paymentStatus ? "#c8e6c9" : "#ffcdd2",
        color: paymentStatus ? "#388e3c" : "#d32f2f",
        fontWeight: "bold",
      }}
    />
  );
};

export default PaymentStatusBadge;
